let Vue = require('vue');
let modalTemplate = require('templates/portals/index/modal-template.html');

Vue.component('portal-modal', {
    twoWay: true,
    template: modalTemplate,
    props: {
        portal : {
            type: Object
        },
        show: {
            type: Boolean,
            required: true,
            twoWay: true
        }
    },
    data: () => ({

    }),
    methods: {

    }
});


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/portals/index/modal-template.js